// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bolt-checkbox {
  border-radius: 4px;
  color: rgba(0, 0, 0, .9);
  color: var(--text-primary-color,rgba(0, 0, 0, .9));
  display: inline-flex;
  align-items: center;
}
.bolt-checkbox:focus {
  outline: none;
}
@media (forced-colors: active) {
  .bolt-checkbox:focus {
    border: 2px solid;
    border-color: Highlight;
  }
}
.bolt-checkbox.disabled {
  color: rgba(0, 0, 0, .38);
  color: var(--text-disabled-color,rgba(0, 0, 0, .38));
  cursor: default;
}
@media (forced-colors: active) {
  .bolt-checkbox.disabled {
    forced-color-adjust: none;
    color: graytext;
  }
}
@media (forced-colors: active) {
  .bolt-checkbox.disabled .bolt-checkmark {
    border-color: graytext;
    color: graytext;
  }
}
.bolt-checkbox.disabled.checked .bolt-checkmark {
  background-color: rgba( 200, 200, 200 ,  1 );
  background-color: rgba( var(--palette-neutral-20,200, 200, 200) ,  1 );
}
@media (forced-colors: active) {
  .bolt-checkbox.disabled.checked .bolt-checkmark {
    background-color: transparent;
    border-color: graytext;
  }
}
.bolt-checkbox.disabled:not(.checked) .bolt-checkmark {
  border:  1px solid;
  border-color: rgba( 200, 200, 200 ,  1 );
  border-color: rgba( var(--palette-neutral-20,200, 200, 200) ,  1 );
}
@media (forced-colors: active) {
  .bolt-checkbox.disabled:not(.checked) .bolt-checkmark {
    border-color: graytext;
  }
}
.bolt-checkbox.labelled {
  padding: 2px 4px 2px 5px;
}
.bolt-checkbox:not(.labelled) {
  margin: 2px;
}
.bolt-checkbox.checked .bolt-checkmark {
  border: 1px solid transparent;
  background-color: rgba(0, 120, 212, 1);
  background-color: var(--communication-background,rgba(0, 120, 212, 1));
  color: rgba(255, 255, 255, 1);
  color: var(--text-on-communication-background,rgba(255, 255, 255, 1));
}
body.ms-vss-web-vsts-theme-hc-dark .bolt-checkbox.checked .bolt-checkmark {
  background-color: rgba(255, 255, 255, 1);
  background-color: var(--background-color,rgba(255, 255, 255, 1));
  border: 1px solid rgba(0, 0, 0, .9);
  border: 1px solid var(--text-primary-color,rgba(0, 0, 0, .9));
}
body.ms-vss-web-vsts-theme-hc-dark .bolt-checkbox.checked .bolt-checkmark .fabric-icon {
  color: rgba(0, 0, 0, .9);
  color: var(--text-primary-color,rgba(0, 0, 0, .9));
}
body.ms-vss-web-vsts-theme-hc-light .bolt-checkbox.checked .bolt-checkmark {
  background-color: rgba(255, 255, 255, 1);
  background-color: var(--background-color,rgba(255, 255, 255, 1));
  border: 1px solid rgba(0, 0, 0, .9);
  border: 1px solid var(--text-primary-color,rgba(0, 0, 0, .9));
}
body.ms-vss-web-vsts-theme-hc-light .bolt-checkbox.checked .bolt-checkmark .fabric-icon {
  color: rgba(0, 0, 0, .9);
  color: var(--text-primary-color,rgba(0, 0, 0, .9));
}
.bolt-checkbox:not(.checked):not(.disabled) .bolt-checkmark {
  border: 1px solid rgba(0, 0, 0, .55);
  border: 1px solid var(--text-secondary-color,rgba(0, 0, 0, .55));
}
@media (forced-colors: active) {
  .bolt-checkbox:not(.checked):not(.disabled) .bolt-checkmark {
    border-color: rgba(0, 0, 0, .9);
    border-width: 2px;
    background-color: transparent;
  }
}
.bolt-checkbox:not(.checked):not(.disabled) .bolt-checkmark > .fabric-icon {
  visibility: hidden;
}
body.ms-vss-web-vsts-theme-hc-dark .bolt-checkbox:hover:not(.disabled):not(.checked) .bolt-checkmark {
  background-color: rgba( 244, 244, 244 ,  1 );
  background-color: rgba( var(--palette-neutral-4,244, 244, 244) ,  1 );
  border-color: Highlight;
  border-width: 2px;
}
body.ms-vss-web-vsts-theme-hc-light .bolt-checkbox:hover:not(.disabled):not(.checked) .bolt-checkmark {
  background-color: rgba( 244, 244, 244 ,  1 );
  background-color: rgba( var(--palette-neutral-4,244, 244, 244) ,  1 );
  border-color: Highlight;
  border-width: 2px;
}
body.ms-vss-web-vsts-theme-hc-dark .bolt-checkbox:hover:not(.disabled).checked .bolt-checkmark {
  border: 2px solid Highlight;
}
body.ms-vss-web-vsts-theme-hc-dark .bolt-checkbox:hover:not(.disabled).checked .bolt-checkmark .fabric-icon {
  color: Highlight;
}
body.ms-vss-web-vsts-theme-hc-light .bolt-checkbox:hover:not(.disabled).checked .bolt-checkmark {
  border: 2px solid Highlight;
}
body.ms-vss-web-vsts-theme-hc-light .bolt-checkbox:hover:not(.disabled).checked .bolt-checkmark .fabric-icon {
  color: Highlight;
}

.bolt-checkmark {
  border-radius: 0.25rem;
  color: transparent;
  padding: 1px;
  height: 1rem;
  width: 1rem;
  transition: background-color 0.1s ease, border-width 0.1s ease;
}

.bolt-checkbox-label {
  padding-left: 10px;
  padding-bottom: 1px;
}

.bolt-focus-visible .bolt-checkbox.bolt-focus-treatment:focus {
  animation: ms-focus-shadow-with-border-pulse 4s ease-in-out infinite;
}
@media (forced-colors: active) {
  .bolt-focus-visible .bolt-checkbox.bolt-focus-treatment:focus {
    animation: none;
  }
}
.bolt-focus-visible .bolt-checkbox.bolt-focus-treatment:focus {
  box-shadow: 0 0 0 3px rgba(0, 120, 212, 0.23), 0 0 0 1px rgba(0, 120, 212, 1);
  box-shadow: 0 0 0 3px var(--focus-pulse-max-color,rgba(0, 120, 212, 0.23)), 0 0 0 1px var(--focus-border-color,rgba(0, 120, 212, 1));
}
.bolt-focus-visible .bolt-checkbox.bolt-focus-treatment:focus:not(.checked):not(.labelled) .bolt-checkmark {
  border: 1px solid rgba(0, 120, 212, 1);
  border: 1px solid var(--communication-background,rgba(0, 120, 212, 1));
}
@media (forced-colors: active) {
  .bolt-focus-visible .bolt-checkbox.bolt-focus-treatment:focus:not(.checked):not(.labelled) .bolt-checkmark {
    forced-color-adjust: none;
    border-color: highlight;
  }
}
@media screen and (forced-colors: active) and (prefers-color-scheme: light) {
  .bolt-focus-visible .bolt-checkbox.bolt-focus-treatment:focus:not(.checked):not(.labelled) .bolt-checkmark {
    outline: 1px solid highlight;
    outline-offset: 1px;
  }
}
@media (forced-colors: active) {
  .bolt-focus-visible .bolt-checkbox.bolt-focus-treatment:focus:not(.checked):not(.labelled) .bolt-checkmark {
    color: windowtext;
  }
}
.bolt-focus-visible .bolt-checkbox.bolt-focus-treatment:focus.checked:not(.labelled) .bolt-checkmark {
  border: 1px solid rgba(255, 255, 255, 1);
  border: 1px solid var(--background-color,rgba(255, 255, 255, 1));
}
@media (forced-colors: active) {
  .bolt-focus-visible .bolt-checkbox.bolt-focus-treatment:focus.checked:not(.labelled) .bolt-checkmark {
    forced-color-adjust: none;
    border-color: highlight;
  }
}
@media screen and (forced-colors: active) and (prefers-color-scheme: light) {
  .bolt-focus-visible .bolt-checkbox.bolt-focus-treatment:focus.checked:not(.labelled) .bolt-checkmark {
    outline: 1px solid highlight;
    outline-offset: 1px;
  }
}
@media (forced-colors: active) {
  .bolt-focus-visible .bolt-checkbox.bolt-focus-treatment:focus.checked:not(.labelled) .bolt-checkmark {
    color: windowtext;
  }
}
@media (forced-colors: active) {
  .bolt-focus-visible .bolt-checkbox.bolt-focus-treatment:focus .bolt-checkmark {
    forced-color-adjust: none;
    border-color: highlight;
  }
}
@media screen and (forced-colors: active) and (prefers-color-scheme: light) {
  .bolt-focus-visible .bolt-checkbox.bolt-focus-treatment:focus .bolt-checkmark {
    outline: 1px solid highlight;
    outline-offset: 1px;
  }
}
@media (forced-colors: active) {
  .bolt-focus-visible .bolt-checkbox.bolt-focus-treatment:focus .bolt-checkmark {
    color: windowtext;
  }
}

/*# sourceMappingURL=Checkbox.css.map */
`, "",{"version":3,"sources":["webpack://./../azure-devops-ui/src/Components/Checkbox/Checkbox.scss","webpack://./../azure-devops-ui/src/Core/_platformCommon.scss","webpack://./../azure-devops-ui/bin/Components/Checkbox/Checkbox.css","webpack://./../azure-devops-ui/src/_coreStyles.scss"],"names":[],"mappings":"AACA;EACI,kBAAA;EACA,wBC0JW;EDzJX,kDAAA;EACA,oBAAA;EEAF,mBAAmB;AFEjB;AEAJ;EACE,aAAa;ACuCX;ADrCJ;EACE;IFCU,iBAAA;IECR,uBAAuB;EACzB;AFEE;AEAJ;EFEQ,yBAAA;EEAN,oDAAoD;EC6BlD,eAAA;AD3BJ;AACA;EACE;IACE,yBAAyB;IACzB,eAAe;ECuBf;ADrBJ;AACA;EACE;IACE,sBAAsB;IACtB,eAAe;EFEX;AEAR;AACA;ECcI,4CAAA;EHfI,sEAAA;AEIR;AACA;EACE;IACE,6BAA6B;IFEzB,sBAAA;EACI;AEAZ;ACKI;EHNI,kBAAA;EEIN,wCFAc;EECd,kEAAkE;AACpE;AFGI;EACI;IEDJ,sBAAsB;EFItB;AEFJ;AACA;EFKI,wBAAA;AEHJ;AACA;EFKQ,WCiH2B;ACpHnC;AD4UQ;EDtUI,6BCyFM;EDxFN,sCAAA;EEHV,sEAAsE;EFK5D,6BAAA;EACI,qECyFD;AC5Ff;ADwUQ;EDzUI,wCCyFM;EDxFN,gEAAA;EEIV,mCAAmC;EFFzB,6DAAA;AEIZ;AACA;EFCI,wBAAA;EACI,kDAAA;AECR;AC5BI;EH0BA,wCAAA;EEKF,gED+Ea;EC9Eb,mCFDU;EEEV,6DFDU;AEEZ;AACA;EFAQ,wBAAA;EACI,kDAAA;AEEZ;ADiTQ;ED5SQ,oCCFJ;EDGI,gEAAA;AEFhB;AACA;ED+SQ;ID/SQ,+BCFJ;IDGI,iBAAA;IACA,6BAAA;EEGd;ADuSM;ACrSR;EACE,kBAAkB;AFEJ;AEAhB;EACE,4CAA4C;EDoStC,qEAAA;EDvSQ,uBAAA;EEMd,iBAAiB;AFJH;AEMhB;EACE,4CAA4C;EAC5C,qEAAqE;EFAvE,uBAAA;EACI,iBAAA;AEEJ;AACA;EFAI,2BAAA;AEEJ;AACA;EACE,gBAAgB;AAClB;AFAA;EACI,2BAAA;AEEJ;AACA;EACE,gBAAgB;AFAlB;;AEGA;EC9EI,sBAAA;EH2EJ,kBAAA;EEME,YClEM;EDmEN,YAAY;EACZ,WAAW;EFRb,8DAAA;AEUA;;AFPI;EACI,kBAAA;EEUN,mBAAmB;ACzFjB;;AD4FJ;EACE,oECvDM;ADwDR;AACA;ECtDI;IHqCA,eAAA;EEoBF;AACF;AACA;EACE,6EAA6E;ECrG3E,oIAAA;ADuGJ;AACA;EACE,sCAAsC;EACtC,sEAAsE;AFnBpE;AEqBJ;EACE;IC7GE,yBAAA;IHuFA,uBAAA;EEyBF;AACF;AACA;EACE;IC1EE,4BAAA;IH8CA,mBAAA;EE+BF;AACF;AACA;EACE;ICzHE,iBAAA;EHuFA;AEqCJ;AACA;EACE,wCAAwC;EC9HtC,gEAAA;ADgIJ;AACA;EACE;IACE,yBAAyB;IACzB,uBAAuB;EC3FvB;AD6FJ;AACA;EACE;IACE,4BAA4B;IAC5B,mBAAmB;EC1InB;AD4IJ;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,yBAAyB;IACzB,uBAAuB;EACzB;AACF;AACA;EACE;IACE,4BAA4B;IAC5B,mBAAmB;EACrB;AACF;AACA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA,uCAAuC","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
